import { gql } from '@apollo/client/core';

export const POLL_INTERVAL = 2000;

export const SKIP_MUTATION = gql`
  mutation SkipChallenge($trackID: String!, $challengeID: String!, $userID: String, $inviteID: String) {
    skipChallenge(trackID: $trackID, challengeID: $challengeID, userID: $userID, inviteID: $inviteID)
  }
`;

export const SKIP_TO_MUTATION = gql`
  mutation SkipToChallenge(
    $trackID: String!
    $challengeID: String!
    $userID: String
    $inviteID: String
    $force: Boolean
  ) {
    skipToChallenge(trackID: $trackID, challengeID: $challengeID, userID: $userID, inviteID: $inviteID, force: $force) {
      id
      status
    }
  }
`;
